import { render, staticRenderFns } from "./DashboardCommunityCard.vue?vue&type=template&id=3bd18ad6&scoped=true&"
import script from "./DashboardCommunityCard.vue?vue&type=script&lang=js&"
export * from "./DashboardCommunityCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCommunityCard.vue?vue&type=style&index=0&id=3bd18ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd18ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
